"use client";

import React, { JSX, lazy, Suspense, useState } from "react";
// import dynamic from "next/dynamic";
import {
  ExternalVideoRecordFragmentQueryData,
  ResponsiveImage,
} from "@/interface/blocks";

/*const MediaCarousel = dynamic(
  () => import("@/components/datocms/client/MediaCarousel"),
  {
    ssr: true,
  }
);*/
const MediaCarousel = lazy(
  () => import("@/components/datocms/client/MediaCarousel")
);

export default function OnClickCarousel({
  children,
  title,
  description,
  carouselTextArea,
  medias,
  externalVideos,
}: {
  children: React.ReactNode;
  title: string;
  description: string;
  carouselTextArea?: JSX.Element;
  medias: Array<{ responsiveImage: ResponsiveImage }>;
  externalVideos: ExternalVideoRecordFragmentQueryData[];
}) {
  const [isShowing, setIsShowing] = useState(false);

  const carousel = (
    <Suspense fallback={<></>}>
      <MediaCarousel
        title={title}
        description={description}
        medias={medias}
        externalVideos={externalVideos}
        customTextElement={carouselTextArea}
        isFullscreen={true}
        closeFullscreen={() => setIsShowing(false)}
      />
    </Suspense>
  );

  return (
    <>
      <button onClick={() => setIsShowing(true)}>{children}</button>
      {isShowing && carousel}
    </>
  );
}
